import { render, staticRenderFns } from "./activeTask.vue?vue&type=template&id=018caa2c&scoped=true&"
import script from "./activeTask.vue?vue&type=script&lang=js&"
export * from "./activeTask.vue?vue&type=script&lang=js&"
import style0 from "./activeTask.vue?vue&type=style&index=0&id=018caa2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018caa2c",
  null
  
)

export default component.exports